




import { Component, Vue, Prop } from "vue-property-decorator";

//компонент "обертка" для удобного использования ui-dropdown
@Component({
  name: "ui-date-range"
})
export default class UiDateRangeComponent extends Vue {
  @Prop({required: true}) value: Object; // filter model
  @Prop({default: 'dateFrom'}) fromField: string;
  @Prop({default: 'dateTo'}) toField: string;
  onChangeDateFilter(dateStart: Date, dateEnd: Date) {
    (this.value as any)[this.fromField] = dateStart;
    (this.value as any)[this.toField] = dateEnd;
  }
  dateFrom: Date = null;
  dateTo: Date = null;
  datesAreTheSame(first: Date, second: Date): boolean {
    return first.getFullYear() === second.getFullYear() &&
      first.getMonth() === second.getMonth() &&
      first.getDate() === second.getDate();
  }
  created() {
    var from = (this.value as any)[this.fromField];
    if (from) {
      if (this.datesAreTheSame(from, new Date())) {
        (this.value as any)[this.fromField] = null;
      } else {
        this.dateFrom = from;
      }
    }
    var to = (this.value as any)[this.toField];
    if (to) {
      if (this.datesAreTheSame(to, new Date())) {
        (this.value as any)[this.toField] = null;
      } else {
        this.dateTo = to;
      }
    }
  }
}
